<template>
  <div>
    <h5
      v-if="promotions && promotions.length > 0"
      :id="'product-details-offers'+productId"
						data-test="promotionSectionHeading"
    >
      Offers
    </h5>
    <div
      v-for="(promotion,key) in promotions"
      :key="key"
    >
      <p v-if="promotion && promotion.promotion_id && promotion.promotion_percentage"
												:data-test="'promotionSectionPromoSvgSpan'+key"
												:id="'promotionSectionPromoSvgSpan'+key"
						class="mb-0">
        <span class="icon icon-promotion"
													:data-test="'promotionSectionPromoIcon'+key"
													:id="'promotionSectionPromoIcon'+key">
          <!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
          <svg
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 29.5 29.5"
            style="enable-background:new 0 0 29.5 29.5;"
            xml:space="preserve"
												:data-test="'promotionSectionPromoSvg'+key"
          >
            <g>
              <path d="M15.205,0.043L1.059,15.202L0,16.262l12.793,
                     11.812l1.561,1.41l14.67-16.033L29.5,0.016L15.205,
                     0.043z M22.027,9.428
                   c-1.461,0-2.646-1.186-2.646-2.645c0-1.463,
                    1.186-2.648,2.646-2.648s2.646,1.186,2.646,
                    2.648 C24.674,8.243,23.488,9.428,22.027,9.428z">
              </path></g>
          </svg>
        </span>
        Extra {{promotion.promotion_percentage}} % off* with {{promotion.promotion_id}} (Price inclusive of discount)
      </p>
      <p v-if="promotion && promotion.promotion_id && promotion.promotion_amount > 0"
												:data-test="'promotionSectionPromoAmtSvgSpan'+key"
												:id="'promotionSectionPromoAmtSvgSpan'+key"
						class="mb-0">
        <span class="icon icon-promotion"
													:data-test="'promotionSectionPromoAmtIcon'+key"
													:id="'promotionSectionPromoAmtIcon'+key">
          <svg
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 29.5 29.5"
            style="enable-background:new 0 0 29.5 29.5;"
            xml:space="preserve"
												:data-test="'promotionSectionPromoAmtSvg'+key"
          >
            <g>
              <path d="M15.205,0.043L1.059,15.202L0,16.262l12.793,11.812l1.561,
            1.41l14.67-16.033L29.5,0.016L15.205,0.043z M22.027,
            9.428 c-1.461,0-2.646-1.186-2.646-2.645c0-1.463,1.186-2.648,
            2.646-2.648s2.646,1.186,2.646,2.648 C24.674,8.243,23.488,
            9.428,22.027,9.428z">
              </path></g>
          </svg>
        </span>
        Instant discount of {{promotion.promotion_amount | currencyConversion}}
        also with {{promotion.promotion_id}} (Price inclusive of discount)
      </p>
    </div>
  </div>
</template>

<script>
export default {
	name: 'promotion-section',
	props: {
		promotionalPrice: {},
		productId: null
	},
	data () {
		return {
			promotions: {}
		}
	},
	beforeMount () {
		this.promotions = this.promotionalPrice
	},
	watch: {
		promotionalPrice: {
			handler (val) {
				this.promotions = this.promotionalPrice
			},
			deep: true
		}
	}
}
</script>
